import { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft } from "lucide-react";
import ExperienceEditor from "./content/ExperienceEditor";
import EducationEditor from "./content/EducationEditor";
import CertificationsEditor from "./content/CertificationsEditor";
import SkillsEditor from "./content/SkillsEditor";
import ServicesEditor from "./content/ServicesEditor";
import ProfileEditor from "./content/ProfileEditor";

const TABS = [
  { k: "experience", l: "Erfahrung", C: ExperienceEditor },
  { k: "education", l: "Ausbildung", C: EducationEditor },
  { k: "certifications", l: "Zertifikate", C: CertificationsEditor },
  { k: "skills", l: "Skills", C: SkillsEditor },
  { k: "services", l: "Services", C: ServicesEditor },
  { k: "profile", l: "Profiltexte", C: ProfileEditor },
];

export default function AdminContent() {
  const [tab, setTab] = useState("experience");
  const Active = TABS.find((t) => t.k === tab)?.C || ExperienceEditor;

  return (
    <div data-testid="admin-content-page" className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-16 pb-24">
      <Helmet>
        <title>Inhalte verwalten | Admin · Karim Benna IT Consulting</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <Link
        to="/admin"
        className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-mono text-[var(--text-2)] hover:text-[var(--gold)] mb-6"
      >
        <ArrowLeft size={14} /> Dashboard
      </Link>
      <h1 className="font-display text-3xl lg:text-4xl tracking-tight mb-8">Inhalte verwalten</h1>

      <div className="border-b hairline flex gap-6 mb-10 overflow-x-auto">
        {TABS.map((t) => (
          <button
            key={t.k}
            onClick={() => setTab(t.k)}
            data-testid={`content-tab-${t.k}`}
            className={`py-3 -mb-px border-b-2 transition-colors font-mono text-xs uppercase tracking-[0.2em] whitespace-nowrap ${
              tab === t.k ? "border-[var(--gold)] text-[var(--gold)]" : "border-transparent text-[var(--text-2)] hover:text-[var(--text-0)]"
            }`}
          >
            {t.l}
          </button>
        ))}
      </div>

      <Active />
    </div>
  );
}
